import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";

// css
import styles from "./MealsPop.module.scss";
import Select from "react-select";
import { useForm } from "react-hook-form";
import {
  useAddMealMutation,
  useUpdateMealMutation,
} from "../../../store/services/mealService";
import toast from "react-hot-toast";

const mealOptions = [
  { value: "Breakfast", label: "Breakfast" },
  { value: "Lunch", label: "Lunch" },
  { value: "Dinner", label: "Dinner" },
];

const MealsPop = ({ title, modalOpen, setModalOpen, edit }) => {
  console.log("edit", edit);

  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    mode: "onTouched", // Validation mode set to 'onTouched'
    defaultValues: {
      name: edit?.name || "",
      mealCount: edit?.mealCount || "",
      description: edit?.description || "",
      status: edit?.status || "active",
      mealType: edit?.mealType || [],
    },
  });
  const [selectedMeals, setSelectedMeals] = useState(
    edit?.mealType
      ? mealOptions.filter((option) => edit.mealType.includes(option.value))
      : []
  );
  const [addMeal, { isLoading: isAdding }] = useAddMealMutation();
  const [updateMeal, { isLoading: isUpdating }] = useUpdateMealMutation();

  // Handler for react-select
  const handleMealChange = (selectedOptions) => {
    setSelectedMeals(selectedOptions || []);
    const mealValues = selectedOptions
      ? selectedOptions.map((option) => option.value)
      : [];
    setValue("mealType", mealValues); // Update react-hook-form state with an array of values
  };

  // Submit handler
  const onSubmit = async (data) => {
    try {
      if (edit !== null) {
        // Update existing meal
        await updateMeal({
          mealId: edit._id,
          updatedData: data,
        });
      } else {
        await addMeal(data).unwrap(); // Call deleteMeal and handle success
      }
      setModalOpen(false);
      return toast.success(`Meal ${edit ? "updated" : "Added"} successfully`);
    } catch (error) {
      console.error("Failed to delete the meal:", error); // Handle error
    }
  };

  const hideHandler = () => {
    setModalOpen(false);
  };
  return (
    <Modal
      show={modalOpen}
      className={`${styles.MealsPop} transparentModal`}
      onHide={hideHandler}
      backdrop={true}
      keyboard={false}
      centered
    >
      <Modal.Body className={`${styles.modalBody}`}>
        <div className="mx-auto">
          <h3 className="m-0 fw-bold themeBlue">{title}</h3>
          <Col lg="12" className="my-2">
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Col lg="12" md="12" className="my-2">
                {/* Name Field */}
                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter name"
                    className="form-control"
                    {...register("name", { required: "Please enter name" })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div> */}

                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter name"
                    className="form-control"
                    {...register("name", {
                      required: "Please enter name",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Name cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Name cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  />
                  {errors.name && (
                    <span className="text-danger">{errors.name.message}</span>
                  )}
                </div>

                {/* Meal Count Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Meal Count
                  </label>
                  <input
                    type="number"
                    placeholder="Enter meal count"
                    className="form-control"
                    {...register("mealCount", {
                      required: "Please enter meal count",
                      min: 1,
                    })}
                  />
                  {errors.mealCount && (
                    <span className="text-danger">
                      {errors.mealCount.message}
                    </span>
                  )}
                </div>

                {/* Description Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Description
                  </label>
                  <textarea
                    rows={7}
                    placeholder="Enter description"
                    className="form-control h-auto"
                    // {...register("description", {
                    //   required: "Please enter description",
                    // })}
                    {...register("description", {
                      required: "Please enter description",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Description cannot start with a space";
                        }
                        // if (/[^a-zA-Z0-9\s]/.test(value)) {
                        //   return "Description cannot include special characters or emojis";
                        // }
                        return true;
                      },
                    })}
                  ></textarea>
                  {errors.description && (
                    <span className="text-danger">
                      {errors.description.message}
                    </span>
                  )}
                </div>

                {/* <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Description
                  </label>
                  <textarea
                    rows={7}
                    placeholder="Enter description (max 100 characters)"
                    className="form-control h-auto"
                    {...register("description", {
                      required: "Please enter description",
                      validate: (value) => {
                        if (/^\s/.test(value)) {
                          return "Description cannot start with a space";
                        }
                        if (/[^a-zA-Z0-9\s]/.test(value)) {
                          return "Description cannot include special characters or emojis";
                        }
                        if (value.length > 100) {
                          return "Description cannot exceed 100 characters";
                        }
                        return true;
                      },
                    })}
                  ></textarea>
                  {errors.description && (
                    <span className="text-danger">
                      {errors.description.message}
                    </span>
                  )}
                  <div className="text-muted small">
                    {watch("description")?.length || 0}/50 characters
                  </div>
                </div> */}

                {/* Meal Type (Select) */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Meal Types
                  </label>
                  <Select
                    isMulti
                    name="mealTypes"
                    options={mealOptions}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    value={selectedMeals}
                    onChange={handleMealChange}
                    placeholder="Select Meal Type"
                  />
                  {errors.mealTypes && (
                    <span className="text-danger">
                      {errors.mealTypes.message}
                    </span>
                  )}
                </div>

                {/* Status Field */}
                <div className="py-2">
                  <label className="form-label fw-sbold text-muted ps-2 m-0">
                    Status
                  </label>
                  <ul className="list-unstyled ps-0 mb-0 d-flex align-items-start gap-10 ps-2 flex-wrap">
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="active"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Active
                      </label>
                    </li>
                    <li className="d-flex align-items-center">
                      <input
                        type="radio"
                        value="inactive"
                        {...register("status", {
                          required: "Status is required",
                        })}
                        className="form-check"
                      />
                      <label className="form-label fw-sbold text-muted ps-2 m-0">
                        Inactive
                      </label>
                    </li>
                  </ul>
                  {errors.status && (
                    <span className="text-danger">{errors.status.message}</span>
                  )}
                </div>
              </Col>

              {/* Submit & Cancel Buttons */}
              <Col lg="12" className="my-2">
                <div className="d-flex align-items-center justify-content-center gap-10">
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn"
                    type="submit"
                    disabled={isAdding || isUpdating}
                  >
                    Submit
                  </Button>
                  <Button
                    className="d-flex align-items-center justify-content-center commonBtn GreyBtn"
                    type="button"
                    onClick={() => {
                      setModalOpen(false);
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </Col>
            </Form>
          </Col>

          {/* <div className="btnWrpper mt-4 d-flex align-items-center justify-content-center gap-10">
            <div className="px-2 w-100">
              <Button
                onClick={hideHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100 GreyBtn"
              >
                Cancel
              </Button>
            </div>
            <div className="px-2 w-100">
              <Button
                onClick={confirmHandler}
                className="fw-sbold d-flex align-items-center justify-content-center commonBtn w-100"
              >
                {title}
              </Button>
            </div>
          </div> */}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default MealsPop;
